
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patient/contribute",
      function () {
        return require("private-next-pages/patient/contribute/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patient/contribute"])
      });
    }
  